/**
 * @generated SignedSource<<3613aa0178caf12d011dbec854115ac7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleSpeechInlineWidgetArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleSpeechInlineWidgetGenericArticle">;
  readonly " $fragmentType": "articleSpeechInlineWidgetArticle";
};
export type articleSpeechInlineWidgetArticle$key = {
  readonly " $data"?: articleSpeechInlineWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleSpeechInlineWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleSpeechInlineWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "genericArticleSpeechInlineWidgetGenericArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "3c77551698a033d2bfb851adfc46b31a";

export default node;
